import React from 'react';
import Bonus30or35 from "../../../../components/templateLandings/bonus30or35";
import {PROMO_CODES, RequireCSS} from "../../../../common";

const Bonus30000 = props => {
  if (RequireCSS(props.location.pathname)) require('../../../../assets/bonus30or35Styles/zenit/style.scss');
  return (
    <Bonus30or35
      sumValue="400"
      currency="$"
      lang="en"
      promo={PROMO_CODES.bonus30k}
      payArray={['visa', 'mastercard', 'piastrix']}
    />
  );
};

export default Bonus30000;
